import Vue from 'vue';
import { SButton } from "../../../components/ui-components";
import { SInput } from "../../../components/ui-components";
import LabelNew from '../../../components/base/vacancies/label-new'
import { YM_ID } from "../../constants/constants"
import { formatTimeISO, formatSalary, formatPhone }  from "../../utils/utils"
import useVacancies from '../../domain/use-vacancies'
import PreloaderNew from '../../../components/preloader/preloader-new'

export default Vue.component('vacanciesDetail', {
  components: {
    SButton,
    SInput,
    LabelNew,
    PreloaderNew
  },
  data() {
    return {
      isShowPhone: false,
      vacancies: null,
      loading: false,
      vacancyId: vacancyId,
      employerPhone: employerPhone,
      partnerId: partnerId
    }
  },
  async created() {
   await this.getVacancies(this.vacancyId)
  },
  methods: {
    formatTimeISO,
    formatSalary,
    formatPhone,
    showPhone() {
      this.isShowPhone = true
    },
    async getVacancies(idVacancies) {
      try {
        this.loading = true
        this.vacancies = await useVacancies().getVacancies(idVacancies)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    ym() {
      ym(YM_ID,'reachGoal','vakansii_pokazat_telefon');
    }
  }
});
